import React, { useEffect, useState } from "react";
import { BorderColor } from "@mui/icons-material";
import Button from "../Button";
import { IMAGE_KIT_ENDPOINT_URL} from "../../constants";

const NotificationListItem = React.memo(({ mintcal, onClick }: any) => {
  const [thumbnailHttpUrl, setThumbnailHttpUrl] = useState<string>();

  useEffect(() => {
    (async () => {
 if (mintcal?.thumbnailUrl?.includes("thumbnails/")) {
        setThumbnailHttpUrl(
          `${IMAGE_KIT_ENDPOINT_URL}${mintcal?.thumbnailUrl}`
        );
      } else {
        setThumbnailHttpUrl(mintcal?.thumbnailUrl);
      }
    })();
  }, [mintcal?.thumbnailUrl, setThumbnailHttpUrl]);

  return (
    <div
      onClick={() => onClick(mintcal)}
      className="rounded-3xl bg-kyzzen-secondary md:shadow-lg p-6 flex flex-row mb-8 justify-between cursor-pointer"
    >
      <div className="flex items-start">
        <img
          src={
            thumbnailHttpUrl
              ? thumbnailHttpUrl
              : "/assets/logo/default-digitaleyes-icon.jpeg"
          }
          alt={mintcal?.name + "logo"}
          className="rounded-md h-auto w-28 mr-4"
        />
        <div>
          <h4 className="uppercase font-bold text-lg">{mintcal?.name}</h4>
          {mintcal?.creatorEmail && (
            <h4 className="text-sm font-light mt-2 text-gray-500">
              {`Submitted by ${mintcal?.creatorEmail} on ${new Date(mintcal?.createdAt).toDateString()}`}
            </h4>
          )}

          {mintcal?.launchDate && (
            <h4 className="text-sm font-light mt-1 text-gray-500">
              {`Launch Date & Time: ${new Date(mintcal?.launchDate).toDateString()} ${new Date(mintcal?.launchDate).toLocaleTimeString()}`}
            </h4>
          )}

          {mintcal?.supply && (
            <h4 className="text-sm font-light mt-1 text-gray-500">
              {`Supply: ${mintcal?.supply}`}
            </h4>
          )}
          {/* {mintcal?.price && ( */}
            <h4 className="text-sm font-light mt-1 text-gray-500">
              {`Price: ${mintcal?.price} SOL`}
            </h4>
          {/* )} */}
        </div>
      </div>
      <div>
        <Button type="button" className="text-blue w-full text-sm">
          <BorderColor className="h-4  text-gray-40" />
        </Button>
      </div>
    </div>
  );
});

export default NotificationListItem;
